import type { Board } from "../board";
import { PRIORITY_DEFAULT, type OnPlayerArrive } from "../interfaces";
import { Thing } from "../thing";
import { PowerPlantGateTerminal } from "./powerPlantGateTerminal";
import { VendingMachine, VendingMachineState } from "./vendingMachine";
import { OpenBlastDoorsTerminal } from "./openBlastDoorsTerminal.ts";
import { TerminalState } from "./terminal.ts";

export class PowerPlantGateOnArrival extends Thing implements OnPlayerArrive {
	static key = "PowerPlantGateOnArrival";

	onPlayerArrive(board: Board): void {
		if (!board.gameFlags.activatedPowerPlant) return;

		for (const t of board.getPhysicalThings()) {
			if (t instanceof PowerPlantGateTerminal) {
				t.activate();
			} else if (t instanceof VendingMachine) {
				t.state = VendingMachineState.ON;
			} else if (t instanceof OpenBlastDoorsTerminal) {
				if (t.doorId === "loot" && t.getState() === TerminalState.NO_POWER) t.setState(TerminalState.ACTIVE);
			}
		}

		board.removeThing(this);
	}

	getArrivePriority(): number {
		return PRIORITY_DEFAULT;
	}

	static deserialize(_data: any): PowerPlantGateOnArrival {
		return new PowerPlantGateOnArrival();
	}
}
